<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
              @query="$gjNoticeQuery"
              @reset="$gjReset">
        <gj-country-server-select
            v-model="filter.marketIds"
        ></gj-country-server-select>

        <gj-select
            v-model="filter.rating"
            :options="[
            {id: 1, text: '一星'},
            {id: 2, text: '二星'},
            {id: 3, text: '三星'},
            {id: 4, text: '四星'},
            {id: 5, text: '五星'},
        ]"
            placeholder="全部星级"
            type="multi-check"
            width="145px"
        ></gj-select>

        <gj-select
            v-model="filter.statusList"
            :options="reviewStatusOption"
            placeholder="全部状态"
            :width="'130px'"
            type="multi-check"
        ></gj-select>

        <gj-select
            v-model="filter.lastResult"
            :options="trackingResultsOption"
            placeholder="跟踪结果"
            :width="'150px'"
        ></gj-select>

        <gj-search-input
          v-model="filter.orderId"
          placeholder="请输入订单编号"
          width="140px"
        ></gj-search-input>

        <gj-select-date-picker
          v-model="filter.date"
          :options="[
          {id: 'feedbackDate', text: '评论时间'},
          {id: 'updateTime', text: '更新时间'}
        ]"
          type="daterange"
        ></gj-select-date-picker>

        <template #right>
          <gj-tool-group
            :download="$permission('feedback:export')" download-url="/crm/feedback/export"
            :download-params="globalParams"
            help
          ></gj-tool-group>
          <view-setting
            :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-change="handleChangeView"
            @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>

    <template #table>
      <gj-table
        :data="data"
        adaptParent
        :columns="columns"
        :pagination="pagination"
        ref="gjTable"
        :loading="loading"
        sortable="custom"
        :default-sort="{prop: '', order: 'descending'}"
        :size="'has-picture'"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:orderId="{ row }">
          <app-order-detail
              :modal-mount-to="$el"
            :order-id="row.orderId"
            :market-id="row.marketId"
          ></app-order-detail>
            <gj-copy-icon v-if="isMeaningful(row.orderId)" :content="row.orderId"/>
        </template>

        <template v-slot:rating="{ row }">
          <gj-rate disabled v-model="row.rating"></gj-rate>
        </template>
        <template v-slot:tags="{row}">
          <div style="display:flex">
            <gj-tooltip :text-line="1" effect="light" popperClass="lightTip">
              <template #content>
                  <div class="contenBox">
                      <div class="paddBox">
                          <span v-for="(item,index) in row.tags" :key="index" class="tagSpan">
                              <gj-tag :color="tagColors.orange" type="plain" class="contentLongTag">{{item.name}}</gj-tag>
                          </span>
                      </div>
                  </div>
              </template>
              <span v-for="(item,index) in row.tags" :key="index" class="tagSpan">
                <gj-tag :color="tagColors.orange" type="plain" class="tooLongTag">{{item.name}}</gj-tag>
              </span>
              </gj-tooltip>
              <div v-if="$permission('tag:marking')" class="editIcon" :class="{'gj-cell-display-switch': tableCellEdit}"
                    @click="editTags(row)">
                <i class="el-icon-edit"></i>
              </div>
          </div>
        </template>
        <template v-slot:status="{ row }">
<!--          <gj-select-->
<!--            v-model="row.status"-->
<!--            :clearable="false"-->
<!--            :disabled="!$permission('feedback:edit')"-->
<!--            @input="editStatus(row.id, row.status)"-->
<!--            :options="[-->
<!--                {id: 'Pending', text: '待处理'},-->
<!--                {id: 'Processing', text: '处理中'},-->
<!--                {id: 'Done', text: '已完成'}-->
<!--            ]"-->

<!--          ></gj-select>-->
          {{ row.status | optionText(reviewStatusOption) }}
        </template>
        <template v-slot:lastStar="{ row }">
          <gj-rate disabled v-model="row.lastStar"></gj-rate>
        </template>

<!--        跟踪结果-->
        <template v-slot:lastResult="{ row }">
          <gj-select
              v-model="row.lastResult"
              :clearable="false"
              @input="editResults(row.id, row.lastResult)"
              :options="trackingResultsOption"
              :width="'150px'"
          ></gj-select>
        </template>

        <template v-slot:feedbackDate="{ row }">
          {{row.feedbackDateStr | defaultShow}}
        </template>

          <template v-slot:comments="{ row }">
              <gj-tooltip :text-line="1" :content="row.comments">
                  {{row.comments | defaultShow}}
              </gj-tooltip>
          </template>

        <template v-slot:op="{ row }">
          <!-- <gj-button type="text" @click="openDetail(row)">详情</gj-button> -->
          <gj-button type="text" @click="feedbackLookEmail(row)">查看邮件</gj-button>
          <gj-button type="text" @click="openLog(row.id)">日志</gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
    import {isMeaningfulMixin, queryMixin, responseMixin} from "../../../../minxins";
    import {stateOption,trackingResultsOption} from "../../../../utils/options";
    import {isMeaningful} from "../../../../utils/common";
    import FeedbackDetail from './feedback-detail';
    import AppOrderDetail from "../../../../components/index/app-order-detail";
    import {convertToDate, generateViewParams} from "../../../../utils/date.util";
    import {editFeedbackStatus, exportFeedback, getFeedbackPage, updateLastResult} from "../../../../api/sale";
    import MailModal from "@/views/modules/sale/review/modal/mail-modal";
    import {mapGetters} from "vuex";
    import { getMailList, getEmailAccountCombobox } from "@/api/crm"; // 获取邮件
    import model from "@/views/modules/sale/feedback/viewConfig";
    import EditTagsModal from './edit-tags-modal';
    import { tagColors } from '@/components/tag/tag-colors'

    export default {
        name: "feedback",
        mixins: [isMeaningfulMixin, queryMixin, responseMixin],
        components: {AppOrderDetail},
        computed: {
            ...mapGetters({
              marketOption: 'marketOption',
              markets: 'authMarkets'
            }),
        },

      watch:{
          $route:{
            immediate: true,
            handler() {
              if(sessionStorage.getItem('commentId')){
                this.isInitParams = false;
                this.isAttemptCache = false;
                this.filter = {
                  marketIds: {
                    countryIds: [],
                    marketIds: []
                  },
                  rating: [],
                  status: '',
                  orderId: null,
                  date: {key: 'feedbackDate', value: null},
                }
                this.$gjNoticeQuery();
              }
            },
          }
      },

      mounted() {
        getEmailAccountCombobox().then(res=>{
          //邮箱--对应店铺列表
          this.marketOptions = this.markets.map(m => {
            let r = res.filter(r => r.marketId === m.id)[0];
            if (r) {
              return {
                mailId:r.id,
                ...r,
                ...m,
                status:r.status
              }
            }else {
              return m
            }
          });
        })
      },

        data() {
            return {
              reviewStatusOption: [
                {id: 'Nothing', text: '无状态'},
                {id: 'Pending', text: '待处理'},
                {id: 'Processing', text: '处理中'},
                {id: 'Done', text: '已完成'},
              ],
              trackingResultsOption,
              tagColors,
              filter: {
                  marketIds: {
                    countryIds: [],
                    marketIds: []
                  },
                  rating: null,
                statusList: [],
                  orderId: null,
                  lastResult:'',
                  date: {key: 'feedbackDate', value: null}
              },
              option: {
                  tag: stateOption
              },
              tableCellEdit:true,
              data: [],
              columns: [
                  {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
                  {id: 'orderId', header: '订单编号', field: 'slot:orderId', minWidth: '170px', default: true, disabled: true},
                  {id: 'rating', header: '星级', field: 'slot:rating', minWidth: '130px', default: true, sortable: true},
                  {id: 'comments', header: '评论内容', field: 'slot:comments', minWidth: '180px', default: true},
                  {id: 'tags', header:'标签', field:'slot:tags',minWidth:'120px',default:true},
                  {id: 'buyerEmail', header: '买家邮箱', field: 'buyerEmail', minWidth: '140px', overflowLine: 2, default: true},
                  {id: 'feedbackDateStr', header: '评论时间', field: 'slot:feedbackDate', minWidth: '120px', default: true, sortable: true},
                  {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '160px', default: true, sortable: true},
                  {id: 'createTime', header: '记录时间', field: 'createTime', minWidth: '160px', default: true, sortable: true},
                  {id: 'status', header: '状态', field: 'slot:status', width: '80px', default: true},
                  {id: 'lastStar', header: '最终星级', field: 'slot:lastStar', minWidth: '130px', default: true, sortable: true},
                  {id: 'lastResult', header: '跟踪结果', field: 'slot:lastResult', minWidth: '160px', default: true},
                  {id: 'op', header: '操作', field: 'slot:op', minWidth: '120px', fixed: 'right', default: true, notCustomColumn: true},
              ],
              moduleName: 'FEEDBACK',
              model,
              cacheOptions: {
                useCache: true,
              }
            }
        },
        methods: {
          editTags(row){
                this.$gjCreate(EditTagsModal,{
                    props:{
                        tag:row
                    },
                    on:{
                        created:()=>{
                            this.$gjQuery()
                        }
                    }
                })
            },
            $gjQueryInitParams() {
                return {
                    filter: {
                        marketIds: {
                          countryIds: [],
                          marketIds: []
                        },
                        rating: [],
                      statusList: [],
                        orderId: null,
                      lastResult:'',
                        date: {key: 'feedbackDate', value: null}
                    }
                };
            },
          /**
           *
           * @param params 查询条件参数
           * @override queryMixin
           * @returns {{marketIds: *}}
           */
          $gjCacheCallback(params) {
            return {
              marketIds: params.marketIds
            };
          },
            $gjQuery() {
                // 构造查询参数
                const params = {
                  model: {
                    ratings: this.filter.rating,
                    statusList: this.filter.statusList,
                    orderId: this.filter.orderId,
                    lastResult: this.filter.lastResult
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
              // 如果是从消息中心过来的，那么记得清除调storage
              if(sessionStorage.getItem('commentId')){
                this.isAttemptCache = true;
                params.model.feedbackId = sessionStorage.getItem('commentId');
                sessionStorage.removeItem('commentId');
              }

              // 店铺国家
                if (this.filter.marketIds) {
                    params.model.countryCodes = this.filter.marketIds.countryIds;
                    params.model.marketIds = this.filter.marketIds.marketIds;
                }
                // 时间
                if (isMeaningful(this.filter.date.value)) {
                    if (this.filter.date.key === 'feedbackDate') {
                        params.model.feedbackStartDate = convertToDate(this.filter.date.value[0]);
                        params.model.feedbackEndDate = convertToDate(this.filter.date.value[1]);
                    } else if (this.filter.date.key === 'updateTime') {
                        params.model.updateStartTime = convertToDate(this.filter.date.value[0]);
                        params.model.updateEndTime = convertToDate(this.filter.date.value[1]);
                    }
                }
                this.globalParams = params;
                // 查询
                this.loading = true;
                    getFeedbackPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.data = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            clickDownload() {
                exportFeedback(this.globalParams);
            },
            openLog(id) {
                this.$gjCreate('gj-log-modal', {
                    props: {
                        url: '/crm/feedback/' + id + '/logs',
                        columns: [
                          {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px', sortable: true},
                          {id: 'opUser', header: '操作用户', field: 'slot:userName', minWidth: '100px'},
                          {id: 'op', header: '操作分类', field: 'op',  minWidth: '120px'},
                          {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
                        ],
                        defaultSort: { prop: '', order: '' },
                    }
                });
            },
            openDetail(row) {
                this.$gjCreate(FeedbackDetail, {
                    props: {
                        row: row,
                    }
                })
            },
            feedbackLookEmail(val){
              val.feedbackId = val.id
              this.$gjCreate(MailModal, {
                mountTo: document.getElementById('gj-base-main'),
                props: {
                  feedbackItem: val,
                  marketOptions:this.marketOptions,
                  mailType: 'NF',
                  source:'feedback'
                },
                on: {
                  close: () => {
                    this.$gjNoticeQuery();
                  }
                }
              });
            },
          editResults(id, lastResult) {
            updateLastResult(id,lastResult).then(res=>{
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('更新成功');
                this.$gjResetPage();
              });
            })
          },
            // editStatus(id, status) {
            //     editFeedbackStatus(id, status)
            //         .then((res) => {
            //             this.$gjResponseHandle(res, () => {
            //                 this.$gjMessage.success('更新成功');
            //                 this.$gjResetPage();
            //             });
            //         })
            // },
          generateViewParams,
          loadViewComplete () {
            this.$emit('query')
          },
        }
    }
</script>

<style scoped>
.contentLongTag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooLongTag {
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
}

.tagSpan {
  display: inline-block;
  margin-bottom: 3px;
}

.editIcon {
  cursor: pointer;
  position: relative;
  top: 3px
}

.contenBox {
  max-width: 640px;
  max-height: 120px;
  overflow-y: auto;
}

.paddBox {
  padding: 10px 10px 3px;
}
</style>
